import appEvents from 'events/app';
import checkAuth from 'actions/user/checkAuth';

const REFRESH_CONFIG_INTERVAL = 60000; // 60 seconds in ms

export default class ChatGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleConnected() {
    this.context.executeAction(appEvents.chatClientConnected());
  }

  handleDisconnected() {
    this.context.executeAction(appEvents.chatClientDisconnected());
  }

  handleProviderConfigured() {
    this.context.executeAction(checkAuth);
    window.setInterval(() => this.context.gateways.configurationGateway.refreshConfig(), REFRESH_CONFIG_INTERVAL);
  }
}
